import React from "react";

import { combineClassNames } from "../../utils/appUtils";

import "./DPCard.scss";

// This is a base card component that can be used to create different types of cards.
export const DPCard = ({
  id,
  children,
  onCardClick,
  className,
  dataTestId,
  border,
  hoverable,
  caption,
  size,
  disabled,
}) => {
  const isClickable = !!onCardClick;

  const handleCardClick = (event) => {
    // Don't trigger click when disabled
    if (disabled) return;

    // Prevent card click when internal elements are clicked
    onCardClick?.(event);
  };

  return (
    <div className="dp-card-container" style={{ height: size }}>
      <div
        id={id}
        className={combineClassNames(
          "dp-card-inner",
          isClickable && !disabled && "clickable",
          hoverable && !disabled && "hoverable",
          border,
          disabled && "disabled",
          className
        )}
        onClick={handleCardClick}
        data-test-id={dataTestId}
      >
        {children}
      </div>
      <div className="dp-card-caption">{caption}</div>
    </div>
  );
};

export default DPCard;
